import React, { ReactElement } from "react";
import TextField, { StandardTextFieldProps } from "@mui/material/TextField";
import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";
import { UseFormRegister } from 'react-hook-form'
import { theme } from "../../../theme";


interface FdTextFieldProps extends StandardTextFieldProps {
  label?: string | React.ReactNode;
  placeholder?: string;
  errorMsg?: string | boolean;
  required?: boolean;
  containerSx?: string;
  success?: boolean;
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  textPosition?: string;
  tooltip?:ReactElement;
  register?: UseFormRegister<any>
  name?: string;
  validationObject?: any
}

const FdTextField = (props: FdTextFieldProps) => {
  const {
    label,
    helperText,
    required,
    placeholder,
    errorMsg,
    containerSx,
    success,
    startIcon,
    endIcon,
    textPosition,
    tooltip,
    register,
    name,
    validationObject,
    ...others
  } = props
  return (
  <>
      {/* <FormLabel sx={{fontSize:'12.5px'}}>
        {label}
        {tooltip}
        {required ? (
          <Box component="span" sx={{ color: "error.main" }}>
            *
          </Box>
        ) : (
          ""
        )}
      </FormLabel> */}
      <TextField
        label={label}
        placeholder={placeholder}
        {...others}
        required={required}
        {...register && (
        {...register(props.name || "", { required: required, 
          validate: validationObject
        })})}
        id={props.id}
        helperText={errorMsg}
        fullWidth
      />

      {helperText && (
        <FormHelperText
          sx={{ color: errorMsg ? theme.palette.error.main : "#808080", ml: textPosition === "right" ? "auto" : "" }}
        >
          <Box component="span">{helperText}</Box>
        </FormHelperText>
      )}
      </>
  );
};

export default FdTextField;
